import React from 'react';
import { Menu } from 'antd';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { EventLabels, logEvent } from '../../../slices/global/global.thunks';

export interface NavigationItem {
  label: string;
  path: string;
  key: string;
  disabled: boolean;
}

interface INavigationBarProps {
  navItems: NavigationItem[];
  getCurrentPath?: (urlSplit: string[]) => string;
}

const defaultGetCurrentPath = (url: string[]) => url.pop() || '';

export const NavigationBar: React.FC<INavigationBarProps> = (props: INavigationBarProps) => {
  const { getCurrentPath = defaultGetCurrentPath, navItems } = props;
  const match = useRouteMatch();
  const url = match.url.split('/');
  const currentPath = getCurrentPath(url);
  const dispatch = useDispatch();
  const onOptionClick = (path: string) => {
    if (path.startsWith('/accounts/') && path.endsWith('/users')) {
      dispatch(logEvent({ label: EventLabels.UsersList }));
      return;
    }
    if (path.startsWith('/accounts/') && path.endsWith('/invoices')) {
      dispatch(logEvent({ label: EventLabels.InvoiceList }));
      return;
    }
    if (path.startsWith('/accounts/') && path.endsWith('/billing')) {
      dispatch(logEvent({ label: EventLabels.AccountBilling }));
      return;
    }
    if (path.startsWith('/accounts/') && path.endsWith('/apiKey')) {
      dispatch(logEvent({ label: EventLabels.AccountApiKey }));
      return;
    }
    if (path.startsWith('/accounts/') && path.endsWith('/sso')) {
      dispatch(logEvent({ label: EventLabels.AccountSSO }));
    }
  };
  return (
    <Menu mode="horizontal" selectedKeys={[currentPath]}>
      {navItems.map((item) => (
        <Menu.Item disabled={item.disabled} key={item.key}>
          <NavLink to={item.path} onClick={() => onOptionClick(item.path)}>{item.label}</NavLink>
        </Menu.Item>
      ))}
    </Menu>
  );
};
